module.exports = __webpack_public_path__ + "images/unit-icons/new/10x10.svg";